/** When set, AuthModal stays on the current page after login (no redirect home). */
export const AUTH_STAY_ON_PAGE_KEY = "authStayOnPage";

export function enableAuthStayOnPage(): void {
  sessionStorage.setItem(AUTH_STAY_ON_PAGE_KEY, "1");
}

export function consumeAuthStayOnPage(): boolean {
  const stay = sessionStorage.getItem(AUTH_STAY_ON_PAGE_KEY) === "1";
  if (stay) sessionStorage.removeItem(AUTH_STAY_ON_PAGE_KEY);
  return stay;
}

export function isAuthStayOnPageEnabled(): boolean {
  return sessionStorage.getItem(AUTH_STAY_ON_PAGE_KEY) === "1";
}
